import React from "react";
import { Link } from "react-router-dom";
import MonitoringArticle from "../components/MonitoringArticle";
import { usePageTitle } from "../hooks/usePageTitle";

function MonitoringPage() {
  usePageTitle("Monitoring en infrastructure");
  return (
    <div className="terraform-page">
      <Link to="/blog" className="article-back-btn">← Blog</Link>
      <MonitoringArticle />
    </div>
  );
}

export default MonitoringPage;
